/**
 * launchBarRoutes — Jun 2026
 * ================================================================
 * Pure URL matcher for the <LaunchCommandBar /> context-aware hiding
 * logic. Mirrors `operatingBarRoutes.js` so it can be unit-tested
 * without pulling in axios / the API client.
 */

/**
 * @param {{ key: string }} item
 * @param {string} pathname   — react-router's `location.pathname`
 * @param {string} search     — react-router's `location.search`
 * @param {string|number|null|undefined} businessId
 * @returns {boolean} true when the ITEM points at the URL the founder is already on
 */
export function isCurrentLaunchRoute(item, pathname, search, businessId) {
  if (!item || !businessId) return false;
  switch (item.key) {
    case "business-plan":
      // Jun 2026 · The Business Plan tile now honors the Default
      // Business Plan View pref, so it may point at either the
      // sectioned plan (`/plan`) or the Overview (`/plan/hierarchy`).
      // Treat both as "here" so the active-route pill stays correct.
      return (
        pathname === `/business/${businessId}/plan` ||
        pathname === `/business/${businessId}/plan/hierarchy`
      );
    case "roadmap":
      return pathname === `/business/${businessId}/roadmap`;
    case "log-actuals":
      return pathname === `/business/${businessId}/log-actuals`;
    case "compliance": {
      if (pathname !== "/compliance") return false;
      try {
        const p = new URLSearchParams(search || "");
        return p.get("business") === String(businessId);
      } catch {
        return false;
      }
    }
    default:
      return false;
  }
}
